import {
  Bell,
  Crown,
  Megaphone,
  Radar,
  Search,
  Sparkles,
  SquareKanban,
  Wrench,
  Zap,
} from 'lucide-react';

// Icons an announcement can name. Anything else falls back to the megaphone.
const ICONS = {
  bell: Bell,
  crown: Crown,
  kanban: SquareKanban,
  megaphone: Megaphone,
  radar: Radar,
  search: Search,
  sparkles: Sparkles,
  wrench: Wrench,
  zap: Zap,
};

export const getIcon = (name) => ICONS[name] || Megaphone;

export const TAGS = {
  new: 'New',
  improved: 'Improved',
  fixed: 'Fixed',
};

export const AUDIENCES = {
  freelancers: 'For freelancers',
  clients: 'For clients',
  all: 'Freelancers & clients',
};

export const WHATS_NEW_PATH = '/whats-new';

export const entryId = (announcement) => `announcement-${announcement.slug}`;

// Every item in the bell opens its entry on the What's New page
export const entryHref = (announcement) =>
  `${WHATS_NEW_PATH}#${entryId(announcement)}`;

export const isInternalUrl = (url) => !!url && url.charAt(0) === '/';

// Content for NotificationItem
export const toNotificationContent = (announcement) => ({
  icon: getIcon(announcement.icon),
  title: announcement.title,
  body: announcement.summary,
  href: entryHref(announcement),
});

export const formatDate = (date) =>
  date
    ? new Date(date).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
    : '';

export const formatMonth = (date) =>
  date
    ? new Date(date).toLocaleDateString('en-GB', {
        month: 'long',
        year: 'numeric',
      })
    : '';

// Tracking data shared by every What's New event
export const trackingData = (announcement, source) => ({
  announcement: announcement.slug,
  tier: announcement.tier,
  source,
});

export const STEP_LAYOUTS = ['text', 'flow', 'columns', 'points'];

// A modal step's layout. Older steps have no `layout`, so it's worked out
// from which block the step has.
export const stepLayout = (step) => {
  if (step && STEP_LAYOUTS.includes(step.layout)) {
    return step.layout;
  }

  if (step && step.flow) {
    return 'flow';
  }

  if (step && step.columns) {
    return 'columns';
  }

  if (step && step.points) {
    return 'points';
  }

  return 'text';
};
